<template>
  <div>
    <ListView
      :items="albums"
      :with-sites="false"
      color="primary"
      :create-item="'photo_albums_create'"
      :edit-item="'photo_albums_edit'"
      :site="$attrs.site_key"
      :label="$attrs.site_title"
      :avatar-url="'cover.sizes.50'"
      :items-name="'albums'"
      @remove-item="updateData"
    >
      <template v-slot:info="{ item }">
        <v-btn icon v-if="item.on_top" disabled>
          <v-icon color="green">mdi-pin</v-icon>
        </v-btn>
        <v-btn icon v-if="item.published">
          <v-icon color="green">mdi-check</v-icon>
        </v-btn>
      </template>
    </ListView>
    <!--        Pagination-->
    <v-col cols="12" class="text-lg-center">
      <v-pagination
        v-show="totalPage > 1"
        v-model="page"
        :length="totalPage"
        total-visible="10"
      ></v-pagination>
    </v-col>
    <!--       Pagination end-->
  </div>
</template>

<script>
import ListView from '@/components/ListView'
import api from '@/mixins/api'
import list_view from '@/mixins/list_view'

export default {
  name: 'Albums',
  components: { ListView },
  mixins: [api, list_view],
  data() {
    return {
      albums: [],
      totalPage: 0,
      limit: 20,
      page: 1,
    }
  },
  watch: {
    '$attrs.site_key'() {
      this.updateData()
    },
    page() {
      this.updateData()
    },
  },
  mounted() {
    this.getCounts()
    this.updateData()
  },
  methods: {
    getCounts() {
      this.axios({
        url: `/v1/albums/count`,
        method: 'get',
        params: { page: this.page, limit: this.limit, site_key: this.$attrs.site_key },
      }).then((resp) => {
        this.$log.debug('albums', resp)
        const count = resp.data.count
        this.totalPage = Math.ceil(count / this.limit)
        this.$log.debug('albums total pages', this.totalPage)
      })
    },
    cover(album) {
      return album.cover.url || require('@/assets/images/img_404.png')
    },
    updateData() {
      this.albums = []
      this.axios({
        url: '/v1/albums',
        method: 'get',
        params: { site_key: this.$attrs.site_key, limit: this.limit, page: this.page },
      })
        .then((resp) => {
          this.albums = resp.data || []
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>

<style scoped lang="scss">
.album {
  cursor: pointer;
  height: 300px;
  width: 200px;
}
</style>
